<mat-card appearance="outlined" class="item-detail" fxFlex="100" fxFlexFill>
  <mat-card-content>
    <mat-expansion-panel hideToggle [expanded]="expandedStepState">
      <mat-expansion-panel-header>
        <mat-panel-title fxLayoutAlign="start center">

          <mat-icon *ngIf="!onlyViewer" class="drag-item" fxShow fxHide.lt-md="true">drag_indicator</mat-icon>

          <span class="title" #flow_order_name>{{authorization_scheme.name}}</span>

          <span class="title edit">
            <mat-form-field *ngIf="flow_order_name.hidden">
              <input matInput [hidden]="!flow_order_name.hidden" [(ngModel)]="flow_order.name"
                (keydown.Space)="$event.stopImmediatePropagation();" minlength="3" maxlength="50" #edit>
            </mat-form-field>
          </span>


        </mat-panel-title>

        <!-- <button (click)="openAs()" mat-icon-button fxShow fxHide.lt-md="true">
          <mat-icon class="icon-edit" svgIcon="icon_edit"></mat-icon>
        </button> -->

        <button *ngIf="!onlyViewer" class="btn-delete" (click)="remove($event)" mat-icon-button fxShow
          fxHide.lt-md="true">
          <mat-icon class="icon-delete">delete_outline</mat-icon>
        </button>

        <app-action-menu class="mobile-detail" [classIcon]="'action-icon'" fxHide fxShow.lt-md="true"
          *ngIf="authorization_scheme">
          <div class="sheet-container-flow-detail">
            <div class="sheet-header" fxLayoutAlign="start center" fxLayoutGap="10px">
              <div class="icon" fxFlex="40px" fxFlex.xs="30px" fxLayoutAlign="center center">
                <mat-icon inline="true">payment</mat-icon>
              </div>
              <div class="sheet-title">{{authorization_scheme.name}}</div>
            </div>
            <div class="sheet-container" fxLayout="column">

              <div class="table" fxLayout="row" fxLayoutGap="20px"
                *ngFor="let authorization_scheme of authorization_scheme.steps">
                <div class="col">
                  <div class="label">{{ 'flows.detail.autorization.attempt' | translate}}</div>
                  <div class="value" fxLayout="column" fxLayoutAlign="center start">
                    <div class="data" *ngIf="authorization_scheme.first_service.image_path">
                      <img class="service-logo logo-w" src="{{authorization_scheme.first_service.image_path}}">
                    </div>
                  </div>
                </div>
                <div class="col" *ngIf="authorization_scheme.second_service">
                  <div class="label">{{ 'flows.detail.autorization.retry' | translate}}</div>
                  <div class="value" fxLayout="column" fxLayoutAlign="center start">
                    <div class="data" *ngIf="authorization_scheme.second_service.image_path">
                      <img class="service-logo logo-w" src="{{authorization_scheme.second_service.image_path}}"
                        alt="{{authorization_scheme.second}}">
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="label">{{ 'flows.detail.autorization.traffic' | translate}}</div>
                  <div class="value" fxLayout="column" fxLayoutAlign="center start">
                    <div class="data">{{authorization_scheme.percentage}}%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </app-action-menu>

      </mat-expansion-panel-header>
      <div (mousedown)="$event.stopPropagation()" class="detail" fxShow fxHide.lt-md="true"
        *ngIf="authorization_scheme">
        <div class="table" fxLayout="row" fxLayoutGap="60px"
          *ngFor="let authorization_scheme of authorization_scheme.steps">
          <div class="col">
            <div class="label">{{ 'flows.detail.autorization.attempt' | translate}}</div>
            <div class="value" fxLayout="column" fxLayoutAlign="center start">
              <div class="data" *ngIf="authorization_scheme.first_service.image_path">
                <img class="service-logo logo-w" src="{{authorization_scheme.first_service.image_path}}">
              </div>
              <div class="info">{{authorization_scheme.first_service.custom_name}}</div>
            </div>
          </div>
          <div class="col" *ngIf="authorization_scheme.second_service">
            <div class="label">{{ 'flows.detail.autorization.retry' | translate}}</div>
            <div class="value" fxLayout="column" fxLayoutAlign="center start">
              <div class="data" *ngIf="authorization_scheme.second_service.image_path">
                <img class="service-logo logo-w" src="{{authorization_scheme.second_service.image_path}}">
              </div>
              <div class="info">{{authorization_scheme.second_service.custom_name}}</div>
            </div>
          </div>
          <div class="col" *ngIf="authorization_scheme.third_service">
            <div class="label">{{ 'flows.detail.autorization.retry' | translate}}</div>
            <div class="value" fxLayout="column" fxLayoutAlign="center start">
              <div class="data" *ngIf="authorization_scheme.third_service.image_path">
                <img class="service-logo logo-w" src="{{authorization_scheme.third_service.image_path}}">
              </div>
              <div class="info">{{authorization_scheme.third_service.custom_name}}</div>
            </div>
          </div>
          <div class="col">
            <div class="label">{{ 'flows.detail.autorization.traffic' | translate}}</div>
            <div class="value" fxLayout="column" fxLayoutAlign="center start">
              <div class="data">{{authorization_scheme.percentage}}%</div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>

  </mat-card-content>
</mat-card>
